import { FC, useMemo } from 'react'
import {
  IProjectCheckpointInstance,
  IProjectCheckpointCriterion,
} from 'screens/Admin/ProjectCheckpoints/projectCheckpoints.types'
import Card from 'shared/Cards/Card'
import TextField from 'shared/Forms/TextField'
import Grade from 'shared/Grade'
import styles from './ProjectCheckpointInfoCard.module.css'

interface IProps {
  checkpoint: IProjectCheckpointInstance
  stage: IProjectCheckpointInstance['stage']
  checkpointCriteria: IProjectCheckpointCriterion[]
}

const translateStatus = (status: IProjectCheckpointInstance['status']): { text: string; color: string } => {
  switch (status) {
    case 'NOT-OPEN':
      return { text: 'Не открыта', color: 'var(--text-secondary)' }
    case 'OPEN':
      return { text: 'Открыта', color: 'var(--primary)' }
    case 'ON_REVIEW':
      return { text: 'На проверке', color: 'var(--primary)' }
    case 'OVERDUE':
      return { text: 'Просрочена', color: 'var(--alert)' }
    case 'INSPECTED':
      return { text: 'Проверено', color: 'var(--success)' }
    default:
      return { text: status, color: 'var(--text-secondary)' }
  }
}

const ProjectCheckpointInfoCard: FC<IProps> = (props) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  }

  const criteriaGradesMap = useMemo(() => {
    const entries =
      props.checkpoint.inspectionResult?.criteriaResults?.map((result) => [
        result.projectCheckpointCriteriaId,
        result.grade,
      ]) ?? []

    return Object.fromEntries(entries) as Record<string, number>
  }, [props.checkpoint.inspectionResult?.criteriaResults])

  const statusInfo = translateStatus(props.checkpoint?.status)
  const expertComment = props.checkpoint.inspectionResult?.comment
  const grade = props.checkpoint.inspectionResult?.grade

  return (
    <div style={{ display: 'flex', gap: '16px', width: '100%' }}>
      <Card type='normal' style={{ flex: 1 }}>
        <div className='flex-lines'>
          <h2 className='text--caption-l text-700' style={{ marginBottom: '16px' }}>
            информация
          </h2>
          <div className='flex-lines'>
            <div className='flex-space-between'>
              <div className={styles.statusContainer}>
                <TextField header='Статус'>
                  <div className={styles.status}>
                    <span className={styles.statusDot} style={{ backgroundColor: statusInfo.color }} />
                    <span>{statusInfo.text}</span>
                  </div>
                </TextField>
              </div>
              <Grade grade={grade} />
            </div>
            <TextField header='Дата окончания'>{formatDate(props.checkpoint.endsAt)}</TextField>
            <TextField header='Этап'>{props.stage.name}</TextField>
            {expertComment && <TextField header='Комментарий эксперта'>{expertComment}</TextField>}
          </div>
          <div className='grid-form-2'>
            {props.checkpointCriteria.map((criterion) => (
              <TextField key={criterion.id} header={criterion.title}>
                {criteriaGradesMap[criterion.id] ?? '--'}{' '}
                <span className='text--secondary'>/ {criterion.maxBalls}</span>
              </TextField>
            ))}
          </div>
        </div>
      </Card>
    </div>
  )
}

export default ProjectCheckpointInfoCard
